import { useRouter } from 'expo-router'
import { StyleSheet, View } from 'react-native'
import { Text } from 'react-native-paper'
import { Button } from '@/ui/Button'
import { ButtonLink } from './Link'

interface NotFoundProps {
    message?: string
    showHomeButton?: boolean
    showBackButton?: boolean
    homeHref?: string
}

export function NotFound({
    message = 'Page not found',
    showHomeButton = true,
    showBackButton = true,
    homeHref = '/',
}: NotFoundProps) {
    const router = useRouter()

    const handleGoBack = () => {
        if (router.canGoBack()) {
            router.back()
        }
    }

    return (
        <View style={styles.container}>
            <View style={styles.content}>
                <Text variant="displayLarge" style={styles.errorCode}>
                    404
                </Text>
                <Text variant="headlineMedium" style={styles.title}>
                    {message}
                </Text>
                <Text variant="bodyLarge" style={styles.description}>
                    The page you're looking for doesn't exist or has been moved.
                </Text>
            </View>

            <View style={styles.buttonContainer}>
                {showBackButton && (
                    <Button
                        title="Go Back"
                        mode="outlined"
                        icon="arrow-left"
                        onPress={handleGoBack}
                    />
                )}

                {showHomeButton && (
                    <ButtonLink
                        // biome-ignore lint/suspicious/noExplicitAny: Dynamic route href
                        href={homeHref as any}
                        title="Go Home"
                        mode="contained"
                        icon="home"
                    />
                )}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        minHeight: '60%',
    },
    content: {
        alignItems: 'center',
        gap: 12,
        marginBottom: 32,
    },
    errorCode: {
        fontWeight: 'bold',
    },
    title: {
        textAlign: 'center',
    },
    description: {
        textAlign: 'center',
        color: '#666',
    },
    buttonContainer: {
        gap: 12,
        alignItems: 'center',
    },
})
